(() => {
  'use strict';
  const norm = value => String(value).toLowerCase().replace(/[^a-z0-9]/g, '');
  function init(scope = document) {
    scope.querySelectorAll('[data-cozy-gallery]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const $ = s => section.querySelector(s), all = s => [...section.querySelectorAll(s)];
      const variants = JSON.parse($('[data-cozy-variants]').textContent) || [];
      const strings = JSON.parse($('[data-buy-strings]').textContent);
      const form = $('.ch-real-product-form'), add = $('[data-cozy-add]');
      const colors = all('[data-color]'), sizes = all('[data-size]'), packs = all('[data-pack]');
      const track = $('[data-photo-track]'), slides = all('[data-slide]'), dots = all('[data-gallery-dot]'), dialog = $('.ch-photo-dialog');
      const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:section.dataset.currency || 'USD'}).format(n / 100);
      let color = 'Beige', size = 'M', quantity = 1, photoIndex = 0, busy = false, oldOverflow = '';
      const find = (c,s) => variants.find(v => v.options.some(o => norm(o) === norm(c)) && v.options.includes(s));
      const match = () => find(color,size);
      const unit = () => match()?.price ?? (size === 'L' ? 9900 : 6900);
      const setText = (s,v) => { $(s).textContent = v; };
      function update() {
        const variant = match(), price = unit(), total = price * quantity;
        colors.forEach(b => {
          const available = !!find(b.dataset.color,size)?.available;
          b.disabled = !available;
          b.setAttribute('aria-pressed', String(b.dataset.color === color));
          const stock = b.querySelector('[data-color-stock]'); stock.hidden = available;
          stock.textContent = b.dataset.color === 'Grey-green' && size === 'M' ? strings.onlyL : strings.soldOut;
          b.setAttribute('aria-label', b.dataset.color + (available ? '' : ' · '+stock.textContent));
        });
        sizes.forEach(b => {
          b.setAttribute('aria-pressed', String(b.dataset.size === size));
          const v = find(color,b.dataset.size);
          b.querySelector('[data-size-price]').textContent = money(v?.price ?? (b.dataset.size === 'M' ? 6900 : 9900));
        });
        packs.forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.pack) === quantity)));
        all('[data-pack-price]').forEach(b => b.textContent = money(price * Number(b.dataset.packPrice)));
        setText('[data-color-label]', color); setText('[data-unit-price-label]', money(price));
        setText('[data-selection-summary]', `${color} · ${size} · ${quantity === 1 ? strings.oneCarrier : quantity + ' ' + strings.carriers}`);
        setText('[data-order-total]', money(total)); setText('[data-gift-label]', quantity === 1 ? strings.onePillow : quantity + ' ' + strings.pillows);
        setText('[data-gift-value]', money(1999 * quantity));
        setText('[data-included-label]', quantity === 1 ? strings.oneCarrier : quantity + ' ' + strings.carriers);
        setText('[data-sticky-selection]', `${color} · ${size} · ${quantity} × ${money(price)}`);
        form.elements.id.value = variant?.id || ''; form.elements.quantity.value = quantity;
        add.disabled = busy || !variant?.available;
        add.textContent = busy ? strings.adding : variant?.available ? `${strings.add} · ${money(total)}` : strings.unavailable;
        add.setAttribute('aria-busy', String(busy));
      }
      function galleryState(index) {
        photoIndex = Math.max(0,Math.min(slides.length-1,index));
        dots.forEach((b,i) => b.setAttribute('aria-pressed',String(i === photoIndex)));
        setText('[data-gallery-count]', `${photoIndex+1} / ${slides.length}`);
      }
      function goPhoto(index) {
        const i = Math.max(0,Math.min(slides.length-1,index));
        track.scrollTo({left:i * track.clientWidth,behavior:'instant'}); galleryState(i);
      }
      function photo(button) {
        const src = button.dataset.photo, img = slides[0].querySelector('img');
        slides[0].dataset.photo = src; img.src = src + '&width=960';
        img.srcset = [400,640,960,1254].map(w => `${src}&width=${w} ${w}w`).join(', '); img.alt = button.dataset.alt;
        $('[data-included-carrier]').src = src + '&width=240';
        goPhoto(0);
      }
      colors.forEach(b => b.addEventListener('click', () => { if(b.disabled) return; color = b.dataset.color; setText('[data-stock-note]',size === 'M' ? strings.stockNote : ''); photo(b); update(); }));
      sizes.forEach(b => b.addEventListener('click', () => {
        size = b.dataset.size;
        let changed = false;
        if(!match()?.available) {
          const next = colors.find(c => find(c.dataset.color,size)?.available);
          if(next) { color = next.dataset.color; photo(next); changed = true; }
        }
        setText('[data-stock-note]',changed ? strings.stockChanged : size === 'M' ? strings.stockNote : '');
        update();
      }));
      packs.forEach(b => b.addEventListener('click', () => { quantity = Number(b.dataset.pack); update(); }));
      dots.forEach((b,i) => b.addEventListener('click', () => goPhoto(i)));
      track.addEventListener('scroll', () => galleryState(Math.round(track.scrollLeft/track.clientWidth)), {passive:true});
      track.addEventListener('keydown', e => { if(e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); goPhoto(photoIndex + (e.key === 'ArrowRight' ? 1 : -1));} });
      let dragging = false, startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', e => {if(e.pointerType !== 'mouse')return;dragging=false;startX=e.clientX;startScroll=track.scrollLeft;});
      track.addEventListener('pointermove', e => {if(e.pointerType !== 'mouse'||e.buttons!==1)return;const dx=e.clientX-startX;if(Math.abs(dx)>8)dragging=true;if(dragging){track.scrollLeft=startScroll-dx;e.preventDefault();}});
      track.addEventListener('dragstart', e => e.preventDefault());
      slides.forEach(b => b.addEventListener('click', e => {
        if(dragging) { e.preventDefault(); dragging=false; return; }
        const img = dialog.querySelector('img');img.removeAttribute('srcset'); img.src = b.dataset.photo+'&width=1600';img.alt=b.querySelector('img').alt;
        oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();
      }));
      $('[data-cozy-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close',()=>{document.body.style.overflow=oldOverflow;});
      dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
      section.querySelectorAll('a[href="#fit-guide"]').forEach(a => a.addEventListener('click', () => { $('#fit-guide').open = true; }));
      document.querySelectorAll('[data-choose-pack]').forEach(a => a.addEventListener('click', () => { quantity = Number(a.dataset.choosePack); update(); }));
      form.addEventListener('submit', async event => {
        event.preventDefault(); const variant = match(); if(busy || !variant?.available) return;
        busy = true; update(); const error = $('[data-product-error]'); error.hidden = true;
        try { await window.CozyCart.add(variant.id, quantity, {'Included gift':'Free pillow'}); }
        catch(e) { error.textContent = e.message || strings.error; error.hidden = false; }
        finally { busy = false; update(); }
      });
      const initial = variants.find(v => String(v.id) === form.elements.id.value);
      if(initial) { color = colors.find(c => initial.options.some(o => norm(o) === norm(c.dataset.color)))?.dataset.color || color; size = initial.options.includes('L') ? 'L':'M'; }
      const selectedColor = colors.find(b=>b.dataset.color===color);if(selectedColor)photo(selectedColor);
      setText('[data-stock-note]',size === 'M' ? strings.stockNote : '');update();
      const observer = new IntersectionObserver(entries => { const e=entries[0]; $('[data-cozy-sticky]').hidden=e.isIntersecting || e.boundingClientRect.top>0; });
      observer.observe(form);
      document.addEventListener('shopify:section:unload', e => { if(e.target.contains(section)) observer.disconnect(); }, {once:true});
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
